<template>
    <div class="page"
         v-loading.fullscreen.lock="fullscreenLoading"
         element-loading-text="加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.5)">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="100px" :inline="true" size="small"
                 class="query-form" @submit.native.prevent>
            <el-form-item label="所属账号">
                <GridSelectU style="width: 200px;" title="选择所属账号" labelName="userName"
                             labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                             placeholder='请选择所属账号'
                             @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                             dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                             queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item label="子商户号">
                <el-input v-model="queryForm.subAccount" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item label="组织类型">
                <el-select v-model="queryForm.orgType" style="width: 200px;">
                    <el-option v-for="(item,index) in storeOrgTypeStatusEunmList" :key="index" :value="item.key" :label="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="营业执照名称">
                <el-input v-model="queryForm.licenseName" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item label="法人姓名">
                <el-input v-model="queryForm.personName" style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item
                label="银盛支付审核状态"
                prop="thirdStatus"
            >
                <el-select
                    v-model="queryForm.thirdStatus"
                    size="small"
                    placeholder="请选择支付审核状态"
                    clearable
                    style="width: 200px"
                >
                    <el-option v-for="(item,index) in auditStatusEnumList" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label="微信支付审核状态"
                prop="wxpayStatus"
            >
                <el-select
                    v-model="queryForm.wxpayStatus"
                    size="small"
                    placeholder="请选择微信支付认证状态"
                    clearable
                    style="width: 200px"
                >
                    <el-option label="未认证" :value="0"> </el-option>
                    <el-option label="已认证" :value="1"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                label="支付宝支付认证状态"
                prop="alipayStatus"
            >
                <el-select
                    v-model="queryForm.alipayStatus"
                    size="small"
                    placeholder="请选择支付宝支付审核状态"
                    clearable
                    style="width: 200px"
                >
                    <el-option label="未认证" :value="0"> </el-option>
                    <el-option label="已认证" :value="1"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否签约">
                <el-select v-model="queryForm.isSign" style="width: 200px;">
                    <el-option v-for="(item,index) in yesNoEunmList" :key="index" :value="item.key" :label="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreOrgInfoList">查询
                </el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
<!--                    <el-button-->
<!--                        type="primary"-->
<!--                        size="small"-->
<!--                        icon="el-icon-plus"-->
<!--                        @click="addShopStoreOrgInfo"-->
<!--                    >新建-->
<!--                    </el-button>-->
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopStoreOrgInfo(null)"
                    >修改
                    </el-button>
<!--                    <el-button-->
<!--                        type="danger"-->
<!--                        plain-->
<!--                        size="small"-->
<!--                        icon="el-icon-delete"-->
<!--                        :disabled="multipleSelection.length <= 0"-->
<!--                        @click="deleteShopStoreOrgInfo(null)"-->
<!--                    >删除-->
<!--                    </el-button>-->
                </div>
                <div>点击查询展示数据</div>
                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span
                        class="icon-box"
                        @click="refreshShopStoreOrgInfoList"
                    >
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>

            <div class="page-content">
<!--            tab-->
            <el-tabs v-model="tabs" v-if='auditStatusList.length > 0'>

                <!--添加或减少：移除或添加html结构->移除或添加监听的tabs中switch case
                    修改默认显示：tab栏默认显示tabs的值 想默认显示那个直接把下面的name替换掉
                    queryForm.orderStatus的值为默认请求的类型，空表示全部-->
                <el-tab-pane label="" name="null"></el-tab-pane>
                <el-tab-pane :label="'全部'" name="zero"></el-tab-pane>
<!--                (${computeAuditStatus[`status_${index}`]})-->
                <el-tab-pane v-for="(item,index) in auditStatusList" :label="`${item.value}`" :name='"status_"+index'></el-tab-pane>
            </el-tabs>

            <!-- 列表数据 -->
            <el-table
                :data="shopStoreOrginfoList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
                v-loading="loading"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="orgType"
                    label="组织类型"
                    width="140"
                >
                    <template slot-scope="scope">
                        <div v-if="storeOrgTypeStatusEunmList && scope.row.orgType">
                            <el-tag size="small" type="danger" v-if="scope.row.orgType == 3">{{returnStoreOrgTypeStatus(scope.row.orgType)}}</el-tag>
                            <el-tag size="small" v-else>{{returnStoreOrgTypeStatus(scope.row.orgType)}}</el-tag>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="storeId"
                    label="门店信息"
                    width="240"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.store">
                            <div style="text-align: left">店名：{{scope.row.store.storeName}}</div>
                            <div style="text-align: left">简称：{{scope.row.simpleName ? scope.row.simpleName : "--" }}</div>
                            <div style="text-align: left">时间：{{scope.row.store.openHours}}</div>
                            <div style="text-align: left">地址：{{scope.row.store.storeAddress}}</div>
                            <div style="text-align: left">客服电话：{{scope.row.servicePhone ? scope.row.servicePhone : '--'}}</div>
                        </div>
                        <div v-else>暂无关联店铺</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="storeId"
                    label="商户邮箱"
                    width="240"
                >
                    <template slot-scope="scope">
                        <div style="text-align: center ">{{scope.row.serviceEmail ?  scope.row.serviceEmail : '--'  }}</div>
                    </template>
                </el-table-column>

                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="userId"
                    label="用户信息"
                    width="240"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.user">
                            <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                            <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                            <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                        </div>
                        <div v-else>暂无关联用户</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="银盛支付审核状态" width="170">
                    <template slot-scope="scope">
                        <div>
                            <span :class="{'active': scope.row.thirdStatus == 7}">{{computeAuditStatus(scope.row.thirdStatus) }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center"  label="审核状态" width="200">
                    <template slot-scope="scope">

<!--                        <div style="text-align: left">银盛支付审核状态：<span :class="{'active': scope.row.thirdStatus == 2}">{{computeAuditStatus(scope.row.thirdStatus) }}</span></div>-->
                        <div style="text-align: left">微信支付认证状态：<span :class="{'active': scope.row.wxpayStatus}">{{ scope.row.wxpayStatus == 1 ? '已认证' : '未认证' }}</span></div>
                        <div style="text-align: left">支付宝支付认证状态：<span :class="{'active': scope.row.alipayStatus}">{{ scope.row.alipayStatus == 1 ? '已认证' : '未认证' }}</span></div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="resultMsg"
                    label="响应报文"
                    width="180"
                ></el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="审核失败原因" width="170">
                    <template slot-scope="scope">
                        <div v-if="scope.row.store && scope.row.store.status == 3">
                            <span>{{scope.row.store.refuseReason}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="personName"
                    label="法人信息"
                    width="240"
                >
                    <template slot-scope="scope">
                        <div>
                            <div style="text-align: left">法人：{{scope.row.personName}}</div>
                            <div style="text-align: left">证号：{{scope.row.idCard}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="bankAccount"
                    label="开户行信息"
                    width="240"
                >
                    <template slot-scope="scope">
                        <div>
                            <div style="text-align: left">行别：{{scope.row.bankName}}</div>
                            <div style="text-align: left">户名：{{scope.row.bankHolder}}</div>
                            <div style="text-align: left">账号：{{scope.row.bankAccount}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="idCardFacade"
                    label="身份证正面图片"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.idCardFacade'>
                            <el-image
                                @click='updateSrcList(scope.row.idCardFacade)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.idCardFacade"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="idCardBack"
                    label="身份证背面图片"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.idCardBack'>
                            <el-image
                                @click='updateSrcList(scope.row.idCardBack)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.idCardBack"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="licensePic"
                    label="营业执照图片"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.licensePic'>
                            <el-image
                                @click='updateSrcList(scope.row.licensePic)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.licensePic"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="bankCardFacade"
                    label="银行卡正面图片"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.bankCardFacade'>
                            <el-image
                                @click='updateSrcList(scope.row.bankCardFacade)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.bankCardFacade"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="bankCardBack"
                    label="银行卡背面图片"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.bankCardBack'>
                            <el-image
                                @click='updateSrcList(scope.row.bankCardBack)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.bankCardBack"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="wxpayConfirmQrcode"
                    label="微信确认二维码"
                    width="130"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.wxpayConfirmQrcode'>
                            <el-image
                                @click='updateSrcList(scope.row.wxpayConfirmQrcode)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.wxpayConfirmQrcode"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else-if="scope.row.wxpayAuthStatus == 5">驳回，请查看报文</div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="alipayConfirmQrcode"
                    label="支付宝确认二维码"
                    width="144"
                >
                    <template slot-scope="scope">
                        <div v-if='scope.row.alipayConfirmQrcode'>
                            <el-image
                                @click='updateSrcList(scope.row.alipayConfirmQrcode)'
                                style="width: 60px; height: 60px"
                                :src="scope.row.alipayConfirmQrcode"
                                :preview-src-list="srcList"> </el-image>
                        </div>
                        <div v-else-if="scope.row.alipayAuthStatus == 5">驳回，请查看报文</div>
                        <div v-else>-</div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="createTime"
                    label="创建时间"
                    width="180"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="thirdPartyType"
                    label="快付进件状态"
                    width="180"
                >
                <template slot-scope="scope">
                      <div v-if="scope.row.thirdPartyType == 1">待提交</div>
                      <div v-else-if="scope.row.thirdPartyType == 2">审核中</div>
                      <div v-else-if="scope.row.thirdPartyType == 3">进件成功</div>
                      <div v-else>待修改</div>
                </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="fastMsg"
                    label="进件错误信息"
                    width="180"
                >
                </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="550"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div class="operation-label" @click='ShopStoreAudit(scop.row)' v-if='scop.row.store && scop.row.store.status == 1'>
                                <span >审核</span>
                            </div>
                            <div class="operation-label" @click="checkShopStoreOrgInfo(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span >查看</span>
                            </div>
                            <div class="operation-label" @click="editShopStoreOrgInfo(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span >修改</span>
                            </div>
                            <div class="operation-label" @click="resetStatus(scop.row.id,'wechat')" v-if='scop.row.thirdStatus == 7'>
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span >微信重置</span>
                            </div>
                            <div  class="operation-label" @click="resetStatus(scop.row.id,'ali')" v-if='scop.row.thirdStatus == 7'>
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span >支付宝重置</span>
                            </div>
                        </div>
                        <div class="operation">
                            <div class="operation-label" @click="onRegister(scop.row.storeId)" v-if='scop.row.thirdStatus == 0'>
                                <span >提交进件</span>
                            </div>
                            <div class="operation-label" @click="onEditRegister(scop.row.storeId)" v-if='scop.row.thirdStatus == 2'>
                                <span >上传修改资料</span>
                            </div>
                            <div class="operation-label" @click="onUpload(scop.row.storeId)" v-if='scop.row.thirdStatus == 1 || scop.row.thirdStatus == 2'>
                                <span >上传图片</span>
                            </div>
                            <div class="operation-label" @click="onConfirm(scop.row.storeId)" v-if='scop.row.thirdStatus == 3 || scop.row.thirdStatus == 2'>
                                <span >确认资料</span>
                            </div>
                            <div  v-if='scop.row.thirdStatus == 4'>
                                <span @click="onContract(scop.row.storeId,1,scop.row.thirdStatus)" class="operation-label">大额合同申请</span>
                                <span @click="onContract(scop.row.storeId,0,scop.row.thirdStatus)" class="operation-label">正常合同申请</span>
                            </div>
                            <div class="operation-label" @click="onResendSMS(scop.row.storeId)" v-if='scop.row.thirdStatus == 5'>
                                <span >重发短信</span>
                            </div>
                            <div class="operation-label" @click="wxReportV3(scop.row.storeId)" v-if='scop.row.thirdStatus == 7 && scop.row.wxpayNo'>
                                <span >微信认证</span>
                            </div>
                            <div  class="operation-label" @click="wxReport(scop.row.storeId)" v-if='scop.row.thirdStatus == 7 && !scop.row.wxpayNo'>
                                <span >重新报备微信认证</span>
                            </div>
                            <div  class="operation-label" @click="aliReportV3(scop.row.storeId)" v-if='scop.row.thirdStatus == 7 && scop.row.alipayNo'>
                                <span >支付宝认证</span>
                            </div>
                            <div  class="operation-label" @click="aliReport(scop.row.storeId)" v-if='scop.row.thirdStatus == 7 && !scop.row.alipayNo'>
                                <span >重新报备支付宝认证</span>
                            </div>
                            <div class="operation-label" @click="reportBei(scop.row.storeId)" v-if='scop.row.thirdStatus == 7'>
                                <span >申请报备</span>
                            </div>
                            <div class="operation-label" @click="changeInformationInquiry(scop.row.storeId)" >
                                <span >变更信息查询</span>
                            </div>
                            <div v-if="tabs == 'zero' && scop.row.thirdPartyType == 1 " class="operation-label" @click="quickPaymentForIncomingItems(scop.row)" >
                                <span >快付进件</span>
                            </div>
                            <div v-if="tabs == 'zero' && scop.row.thirdPartyType == 4 " class="operation-label" @click="quickPaymentForIncomingModifications(scop.row)" >
                                <span >快付进件修改</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopStoreOrginfoStates[shopStoreOrginfoState]"
                :visible.sync="showDialog"
                width="1000px"
                @close="closeDialog"
            > 
            <div>
                    <el-form
                        :model="shopStoreOrginfo"
                        ref="shopStoreOrginfoForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-tabs type="border-card">
                            <el-tab-pane label="工商信息">
                                <el-form-item
                                    label="组织类型"
                                    prop="orgType"
                                >
                                    <el-select
                                        v-model="shopStoreOrginfo.orgType"
                                        size="small"
                                        placeholder="请选择组织类型"
                                        clearable
                                        style="width: 200px"
                                    >
                                        <el-option v-for="(item,index) in storeOrgTypeStatusEunmList" :label="item.value" :value="item.key"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="mcc编码"
                                    prop="mccCode"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        readonly
                                        v-model="shopStoreOrginfo.mccCodeName"
                                    >
                                        <el-button @click="getMccCode(shopStoreOrginfo.orgType)" slot="append" icon="el-icon-search"></el-button>
                                    </el-input>
                                </el-form-item>
                                <el-form-item
                                    label="执照所属省份"
                                    prop="licenseProvinceId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.licenseProvinceId'
                                        size='small'
                                        placeholder='请选择省份'
                                    >
                                        <el-option
                                            v-for='item in provinceIdList'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="执照所属城市"
                                    prop="licenseCityId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.licenseCityId'
                                        size='small'
                                        placeholder='请选择城市'
                                    >
                                        <el-option
                                            v-for='item in cityIdList'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="执照所属区县"
                                    prop="licenseAreaId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.licenseAreaId'
                                        size='small'
                                        placeholder='请选择区县'
                                    >
                                        <el-option
                                            v-for='item in areaIdList'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="执照所属乡镇"
                                    prop="licenseTownId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.licenseTownId'
                                        size='small'
                                        placeholder='请选择乡镇'
                                    >
                                        <el-option
                                            v-for='item in streetIdList'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            <!--银盛 或 快付-->
                                <div > 
                                <el-form-item
                                    :label="thirdPartyTypeName + '所属省份'"
                                    prop="ysProvinceId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.ysProvinceId'
                                        size='small'
                                        placeholder='请选择省份'
                                    >
                                        <el-option
                                            v-for='item in ysProvinceIdList'
                                            :key='item.cityCd'
                                            :label='item.cityNm'
                                            :value='item.cityCd'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    :label="thirdPartyTypeName +'所属城市'"
                                    prop="ysCityId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.ysCityId'
                                        size='small'
                                        placeholder='请选择城市'
                                    >
                                        <el-option
                                            v-for='item in ysCityIdList'
                                            :key='item.cityCd'
                                            :label='item.cityNm'
                                            :value='item.cityCd'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    :label="thirdPartyTypeName + '属区县'"
                                    prop="ysAreaId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.ysAreaId'
                                        size='small'
                                        placeholder='请选择区县'
                                    >
                                        <el-option
                                            v-for='item in ysAreaIdList'
                                            :key='item.cityCd'
                                            :label='item.cityNm'
                                            :value='item.cityCd'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                </div>
                              <el-form-item
                                    label="终端号"
                                    prop="deviceNo"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.deviceNo"
                                    ></el-input>
                                </el-form-item>

                                <el-form-item
                                    label="营业执照名称"
                                    prop="licenseName"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.licenseName"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="营业执照注册地址"
                                    prop="licenseAddress"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.licenseAddress"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="统一社会信用代码"
                                    prop="licenseNumber"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.licenseNumber"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="经营期限起始"
                                    prop="licenseStartTime"
                                >
                                    <div style="width: 200px;display: flex;align-items: center;">
                                        <el-date-picker
                                            style="flex: 1"
                                            size="small"
                                            v-model="shopStoreOrginfo.licenseStartTime"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                        <el-checkbox style="margin-left: 10px" :true-label="1" :false-label="0" v-model="shopStoreOrginfo.licenseIsPermanent" label="长期"></el-checkbox>
                                    </div>

                                </el-form-item>
                                <el-form-item
                                    label="经营期限结束"
                                    prop="licenseEndTime"
                                    v-if="shopStoreOrginfo.licenseIsPermanent == 0"
                                >
                                    <el-date-picker
                                        style="width: 200px;"
                                        size="small"
                                        v-model="shopStoreOrginfo.licenseEndTime"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item
                                    label="经营范围"
                                    prop="licenseRange"
                                >
                                    <el-input
                                        size="small"
                                        type="textarea"
                                        :rows="8"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.licenseRange"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="营业执照图片"
                                    prop="licensePic"
                                >
                                    <div style="width: 200px;display: flex;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage21">
                                            <img v-if="shopStoreOrginfo.licensePic" :src="shopStoreOrginfo.licensePic" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.licensePic)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <!--                        <el-form-item-->
                                <!--                            label="其他补充资料 如烟草经营许可证"-->
                                <!--                            prop="otherInfor"-->
                                <!--                        >-->
                                <!--                            <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"-->
                                <!--                                       class="avatar-uploader" :show-file-list="false"-->
                                <!--                                       :http-request="uploadImage22">-->
                                <!--                                <img v-if="shopStoreOrginfo.otherInfor" :src="shopStoreOrginfo.otherInfor" class="avatar" size="small" />-->
                                <!--                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
                                <!--                            </el-upload>-->
                                <!--                        </el-form-item>-->
                            </el-tab-pane>
                            <el-tab-pane label="法人信息">
                                <el-form-item
                                    label="法人姓名"
                                    prop="personName"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.personName"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="身份证号"
                                    prop="idCard"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.idCard"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="证件有效期起始"
                                    prop="idCardStartTime"
                                >
                                    <div style="width: 200px;display: flex;align-items: center">
                                        <el-date-picker
                                            style="flex: 1"
                                            size="small"
                                            v-model="shopStoreOrginfo.idCardStartTime"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                        <el-checkbox style="margin-left: 10px" :true-label="1" :false-label="0" v-model="shopStoreOrginfo.idCardIsPermanent" label="长期"></el-checkbox>
                                    </div>
                                </el-form-item>
                                
                                <el-form-item
                                    label="证件有效期结束"
                                    prop="idCardEndTime"
                                    v-if="shopStoreOrginfo.idCardIsPermanent==0"
                                >
                                    <el-date-picker
                                        style="width: 200px;"
                                        size="small"
                                        v-model="shopStoreOrginfo.idCardEndTime"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
                                 <el-form-item
                                    label="客服电话"
                                    prop="servicePhone"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.servicePhone"
                                        @blur="blurService(1)"
                                    ></el-input>
                                </el-form-item>
                                 <el-form-item
                                    label="商户邮箱"
                                    prop="serviceEmail"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.serviceEmail"
                                         @blur="blurService(2)"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="证件地址"
                                    prop="idCardAddress"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.idCardAddress"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="身份证人像面图片"
                                    prop="idCardFacade"
                                >
                                    <div style="display: flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage31">
                                            <img v-if="shopStoreOrginfo.idCardFacade" :src="shopStoreOrginfo.idCardFacade" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.idCardFacade)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="身份证国徽面图片"
                                    prop="idCardBack"
                                >
                                    <div style="display: flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage32">
                                            <img v-if="shopStoreOrginfo.idCardBack" :src="shopStoreOrginfo.idCardBack" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.idCardBack)">查看</el-button>
                                    </div>
                                </el-form-item>
                            </el-tab-pane>
                            <el-tab-pane label="银行信息">
                                <el-form-item
                                    label="对公账户名称/持有人姓名"
                                    prop="bankHolder"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.bankHolder"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="对公账户卡号/银行卡卡号"
                                    prop="bankAccount"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.bankAccount"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="所属银行"
                                    prop="bankName"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.bankName"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="开户支行"
                                    prop="bankSubbranch"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.bankSubbranch"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="银行所在省份"
                                    prop="bankProvinceId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.bankProvinceId'
                                        size='small'
                                        placeholder='请选择省份'
                                    >
                                        <el-option
                                            v-for='item in provinceIdList'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="银行所在城市"
                                    prop="bankCityId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.bankCityId'
                                        size='small'
                                        placeholder='请选择城市'
                                    >
                                        <el-option
                                            v-for='item in cityIdList2'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="银行所在区县"
                                    prop="bankAreaId"
                                >
                                    <el-select
                                        style='width:200px'
                                        v-model='shopStoreOrginfo.bankAreaId'
                                        size='small'
                                        placeholder='请选择区县'
                                    >
                                        <el-option
                                            v-for='item in areaIdList2'
                                            :key='item.id'
                                            :label='item.name'
                                            :value='item.id'
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
<!--                                <el-form-item-->
<!--                                    label="银行所在乡镇"-->
<!--                                    prop="bankTownId"-->
<!--                                >-->
<!--                                    <el-select-->
<!--                                        style='width:200px'-->
<!--                                        v-model='shopStoreOrginfo.bankTownId'-->
<!--                                        size='small'-->
<!--                                        placeholder='请选择乡镇'-->
<!--                                    >-->
<!--                                        <el-option-->
<!--                                            v-for='item in streetIdList2'-->
<!--                                            :key='item.id'-->
<!--                                            :label='item.name'-->
<!--                                            :value='item.id'-->
<!--                                        ></el-option>-->
<!--                                    </el-select>-->
<!--                                </el-form-item>-->
                                <el-form-item
                                    label="银行预留手机号"
                                    prop="bankMobile"
                                >
                                    <el-input
                                        size="small"
                                        style="width: 200px"
                                        v-model="shopStoreOrginfo.bankMobile"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    label="银行卡正面图片"
                                    prop="bankCardFacade"
                                    v-if="shopStoreOrginfo.orgType != 2"
                                >
                                    <div style="display: flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage41">
                                            <img v-if="shopStoreOrginfo.bankCardFacade" :src="shopStoreOrginfo.bankCardFacade" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.bankCardFacade)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="银行卡背面图片"
                                    prop="bankCardBack"
                                    v-if="shopStoreOrginfo.orgType != 2"
                                >
                                    <div style="display: flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage42">
                                            <img v-if="shopStoreOrginfo.bankCardBack" :src="shopStoreOrginfo.bankCardBack" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.bankCardBack)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="变更申请图片"
                                    prop="changeRequestimg"
                                    v-if="shopStoreOrginfoState != 'check' && shopStoreOrginfo.thirdStatus == 7"  
                                >
                                    <div style="display: flex;width: 200px;">
                                        <el-upload  
                                                     :action="action" 
                                                     :headers="header"                 
                                                     :before-upload="beforeImageUpload"
                                                     class="uploademo" 
                                                     :show-file-list="false"
                                                     :http-request="uploadImage55"
                                                     :limit="10"
                                                      list-type="picture"
                                                     >
                                            <!-- <img v-if="shopStoreOrginfo.changeRequestimg" :src="shopStoreOrginfo.changeRequestimg" class="avatar" size="small" /> -->
                                            <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                                              <el-button type="primary">点击上传</el-button>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.changeRequestimg)">查看</el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item
                                    label="对公账户凭证"
                                    prop="bankAccountVoucher"
                                    v-if="shopStoreOrginfo.orgType == 2"
                                >
                                    <div style="display: flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage43">
                                            <img v-if="shopStoreOrginfo.bankAccountVoucher" :src="shopStoreOrginfo.bankAccountVoucher" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.bankAccountVoucher)">查看</el-button>
                                    </div>
                                </el-form-item>
                                 <div  v-if="shopStoreOrginfoState != 'check' && shopStoreOrginfo.thirdStatus == 7"  style="display: flex; align-items: center;justify-content: center;">
                                     <el-button type="primary" @click="submitBankInfo" >银行信息提交银盛确定</el-button>
                                 </div>
                            </el-tab-pane>
                            <el-tab-pane label="认证信息" >
                                   <el-form-item
                                       :label=" thirdPartyTypeName + '支付审核状态' "
                                       prop="thirdStatus"
                                   >
                                       <el-select
                                           v-model="shopStoreOrginfo.thirdStatus"
                                           size="small"
                                           placeholder="请选择支付审核状态"
                                           clearable
                                           style="width: 200px"
                                       >
                                           <el-option v-for="(item,index) in auditStatusList"  :label="item.value" :value="item.key"> </el-option>
                                       </el-select>
                                   </el-form-item>
                                   <el-form-item
                                       :label="thirdPartyTypeName + '属区县子商户号' "
                                       prop="subAccount"
                                   >
                                       <el-input
                                           size="small"
                                           style="width: 200px"
                                           v-model="shopStoreOrginfo.subAccount"
                                       ></el-input>
                                   </el-form-item>
                                   <el-form-item
                                       label="银盛响应报文"
                                       prop="resultMsg"
                                   >
                                       <el-input
                                           size="small"
                                           type="textarea"
                                           :rows="8"
                                           style="width: 200px"
                                           v-model="shopStoreOrginfo.resultMsg"
                                       ></el-input>
                                   </el-form-item>
                                   <el-form-item
                                       label="微信支付认证状态"
                                       prop="wxpayStatus"
                                   >
                                       <el-select
                                           v-model="shopStoreOrginfo.wxpayStatus"
                                           size="small"
                                           placeholder="请选择微信支付认证状态"
                                           clearable
                                           style="width: 200px"
                                       >
                                           <el-option label="未认证" :value="0"> </el-option>
                                           <el-option label="已认证" :value="1"> </el-option>
                                       </el-select>
                                   </el-form-item>
                                   <el-form-item
                                       label="微信商户号1"
                                       prop="wxpayNo"
                                   >
                                       <el-input
                                           size="small"
                                           style="width: 200px"
                                           v-model="shopStoreOrginfo.wxpayNo"
                                       ></el-input>
                                   </el-form-item>
                                   <el-form-item
                                       label="微信商户号2"
                                       prop="wxpayNo1"
                                   >
                                       <el-input
                                           size="small"
                                           style="width: 200px"
                                           v-model="shopStoreOrginfo.wxpayNo1"
                                       ></el-input>
                                   </el-form-item>
                                   <el-form-item
                                       label="微信申请二维码"
                                       prop="wxpayApplyQrcode"
                                   >
                                       <div style="display:flex;width: 200px;">
                                           <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                      class="avatar-uploader" :show-file-list="false"
                                                      :http-request="uploadImage51">
                                               <img v-if="shopStoreOrginfo.wxpayApplyQrcode" :src="shopStoreOrginfo.wxpayApplyQrcode" class="avatar" size="small" />
                                               <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                           </el-upload>
                                           <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.wxpayApplyQrcode)">查看</el-button>
                                       </div>
                                   </el-form-item>
                                   <el-form-item
                                       label="微信法人确认二维码"
                                       prop="wxpayConfirmQrcode"
                                   >
                                       <div style="display:flex;width: 200px;">
                                           <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                      class="avatar-uploader" :show-file-list="false"
                                                      :http-request="uploadImage52">
                                               <img v-if="shopStoreOrginfo.wxpayConfirmQrcode" :src="shopStoreOrginfo.wxpayConfirmQrcode" class="avatar" size="small" />
                                               <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                           </el-upload>
                                           <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.wxpayConfirmQrcode)">查看</el-button>
                                       </div>
                                   </el-form-item>
                                   <el-form-item
                                       label="支付宝支付认证状态"
                                       prop="alipayStatus"
                                   >
                                       <el-select
                                           v-model="shopStoreOrginfo.alipayStatus"
                                           size="small"
                                           placeholder="请选择支付宝支付认证状态"
                                           clearable
                                           style="width: 200px"
                                       >
                                           <el-option label="未认证" :value="0"> </el-option>
                                           <el-option label="已认证" :value="1"> </el-option>
                                       </el-select>
                                   </el-form-item>
                                   <el-form-item
                                       label="支付宝商户号1"
                                       prop="alipayNo"
                                   >
                                       <el-input
                                           size="small"
                                           style="width: 200px"
                                           v-model="shopStoreOrginfo.alipayNo"
                                       ></el-input>
                                   </el-form-item>
                                   <el-form-item
                                       label="支付宝商户号2"
                                       prop="alipayNo1"
                                   >
                                       <el-input
                                           size="small"
                                           style="width: 200px"
                                           v-model="shopStoreOrginfo.alipayNo1"
                                       ></el-input>
                                   </el-form-item>
                                   <el-form-item
                                       label="支付宝申请二维码"
                                       prop="alipayApplyQrcode"
                                   >
                                       <div style="display:flex;width: 200px;">
                                           <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                      class="avatar-uploader" :show-file-list="false"
                                                      :http-request="uploadImage53">
                                               <img v-if="shopStoreOrginfo.alipayApplyQrcode" :src="shopStoreOrginfo.alipayApplyQrcode" class="avatar" size="small" />
                                               <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                           </el-upload>
                                           <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.alipayApplyQrcode)">查看</el-button>
                                       </div>
                                   </el-form-item>
                                   <el-form-item
                                       label="支付宝法人确认二维码"
                                       prop="alipayConfirmQrcode"
                                   >
                                       <div style="display:flex;width: 200px;">
                                           <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                      class="avatar-uploader" :show-file-list="false"
                                                      :http-request="uploadImage54">
                                               <img v-if="shopStoreOrginfo.alipayConfirmQrcode" :src="shopStoreOrginfo.alipayConfirmQrcode" class="avatar" size="small" />
                                               <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                           </el-upload>
                                           <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.alipayConfirmQrcode)">查看</el-button>
                                       </div>
                                   </el-form-item>
                            </el-tab-pane>
                            <el-tab-pane label="签约信息">
                                <el-form-item
                                    label="签约状态"
                                    prop="alipayStatus"
                                >
                                    <el-select
                                        v-model="shopStoreOrginfo.isSign"
                                        size="small"
                                        placeholder="请选择签约状态"
                                        clearable
                                        style="width: 200px"
                                    >
                                        <el-option label="未签约" :value="0"> </el-option>
                                        <el-option label="已签约" :value="1"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="签名图片"
                                    prop="signPic"
                                >
                                   <div style="display:flex;width: 200px;">
                                       <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                  class="avatar-uploader" :show-file-list="false"
                                                  :http-request="uploadImage11">
                                           <img v-if="shopStoreOrginfo.signPic" :src="shopStoreOrginfo.signPic" class="avatar" size="small" />
                                           <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                       </el-upload>
                                       <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.signPic)">查看</el-button>
                                   </div>
                                </el-form-item>
                                <el-form-item
                                    label="合同地址"
                                    prop="contractUrl"
                                >
                                    <div style="display:flex;width: 200px;">
                                        <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                                                   class="avatar-uploader" :show-file-list="false"
                                                   :http-request="uploadImage12">
                                            <img v-if="shopStoreOrginfo.contractUrl" :src="shopStoreOrginfo.contractUrl" class="avatar" size="small" />
                                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        </el-upload>
                                        <el-button style="margin-left: 10px;height: 28px" size="mini" type="primary" @click="getImage(shopStoreOrginfo.contractUrl)">查看</el-button>
                                    </div>
                                </el-form-item>
                            </el-tab-pane>
                            <el-tab-pane label="资质信息">
                                <el-form-item
                                    label="是否需要其他资质"
                                    prop="needQualification"
                                >
                                    <el-select
                                        v-model="shopStoreOrginfo.needQualification"
                                        size="small"
                                        placeholder="请选择是否需要其他资质"
                                        clearable
                                        style="width: 200px"
                                    >
                                        <el-option label="是" :value="1"> </el-option>
                                        <el-option label="否" :value="0"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="资质审核状态"
                                    prop="qualificationStatus"
                                >
                                    <el-select
                                        v-model="shopStoreOrginfo.qualificationStatus"
                                        size="small"
                                        placeholder="请选择是审核状态"
                                        clearable
                                        style="width: 200px"
                                    >
                                        <el-option v-for="(item, index) in auditStatusEnumList" :label="item.value" :value="item.key" :key="index"> </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    label="资质图片"
                                    prop="qualificationPic"
                                >
                                    <div style="display:flex;width: 600px;">
                                        <el-upload
                                            :headers="header"
                                            class="uploadAlbum"
                                            :action="action"
                                            :on-remove="handleRemove"
                                            :file-list="fileList"
                                            :on-success="handleSuccess"
                                            :before-upload="beforeAvatarUpload"
                                            list-type="picture"
                                            accept="jpg,jpeg,png,JPG,JPEG,PNG"
                                            :limit="10"
                                        >
                                            <el-button size="small" type="primary">点击上传</el-button>
                                            <div slot="tip" class="el-upload__tip">只能上传jpg,jpeg,png,JPG,JPEG,PNG文件，且不超过50MB<el-button size="small" style="margin-left: 10px" @click="seeImages" type="primary" v-if="fileList.length > 0">查看图片</el-button></div>
                                        </el-upload>
                                    </div>
                                </el-form-item>
                            </el-tab-pane>
                        </el-tabs>
                        <el-image ref="images" v-show="false" @click='updateSrcList(imageSrc)' style="width: 60px; height: 60px"
                                  :src="imageSrc" :preview-src-list="srcList"> </el-image>
                    </el-form>
                </div>

                <div slot="footer">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="shopStoreOrginfoState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>

            <!--审核功能-->
            <el-dialog title='审核' :visible.sync='retreatDialogVisible' width='30%'
                       :before-close='handleCloseRetreat'>
                <el-form ref='retreatForm' :rules='retreatRules' size='small' :model='retreatForm' label-width='100px'>
                    <el-form-item label='申请说明：'>
                        <el-input style='width: 100%' type='textarea' v-model='applyRemarks'
                                  :disabled='true'></el-input>
                    </el-form-item>
                    <el-form-item label='是否同意：' prop='resource'>
                        <el-radio-group v-model='retreatForm.resource'>
                            <el-radio label='true'>同意</el-radio>
                            <el-radio label='false'>拒绝</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label='驳回原因：' prop='desc' v-if="retreatForm.resource == 'false'">
                        <el-input style='width: 100%' type='textarea' v-model='retreatForm.desc'></el-input>
                    </el-form-item>
                    <!--                <el-form-item label='收益比例：' v-if="retreatForm.resource == 'true'" prop='incomeRatio'>-->
                    <!--                    <el-input style='width: 200px' v-model='retreatForm.incomeRatio'></el-input>-->
                    <!--                </el-form-item>-->
                </el-form>
                <span slot='footer' class='dialog-footer'>
        <el-button @click='handleCloseRetreat'>取 消</el-button>
        <el-button type='primary' @click="retreatSuccess('retreatForm')">确 定</el-button>
      </span>
            </el-dialog>
        </div>

        <mccCide ref="mccCode" @radioItem="radioThis" ></mccCide>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload ,getphp} from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';
import GridSelectU from '@/components/gridselect/index.vue';
import mccCide from '@/components/mccCodeTable/mccCide.vue';
import axios from 'axios';
export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        mccCide
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopStoreOrgInfoList();
                this.getShopStoreOrgInfoList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopStoreOrgInfoList();
                this.getShopStoreOrgInfoList();
                this.$emit('resetCheckState');
            }
        },
        //市
        'shopStoreOrginfo.licenseProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity) {
                    this.shopStoreOrginfo.licenseCityId = '';
                    this.shopStoreOrginfo.licenseAreaId = '';
                    this.shopStoreOrginfo.licenseTownId = '';
                } else {
                    this.getCity = !this.getCity;
                }
                this.getAddress(2,id)
            }, 5);
        },
        //区
        'shopStoreOrginfo.licenseCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea) {
                    this.shopStoreOrginfo.licenseAreaId = '';
                    this.shopStoreOrginfo.licenseTownId = '';
                } else {
                    this.getArea = !this.getArea;
                }
                this.getAddress(3,id)
            }, 10);
        },
        //社区
        'shopStoreOrginfo.licenseAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street) {
                    this.shopStoreOrginfo.licenseTownId = '';
                } else {
                    this.street = !this.street;
                }
                this.getAddress(4,id)
            }, 15);
        },

        //市
        'shopStoreOrginfo.bankProvinceId'(id) {
            
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getCity2) {
                    this.shopStoreOrginfo.bankCityId = '';
                    this.shopStoreOrginfo.bankAreaId = '';
                    this.shopStoreOrginfo.bankTownId = '';
                } else {
                    this.getCity2 = !this.getCity2;
                }
                this.getAddress2(2,id)
            }, 25);
        },
        //区
        'shopStoreOrginfo.bankCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.getArea2) {
                    this.shopStoreOrginfo.bankAreaId = '';
                    this.shopStoreOrginfo.bankTownId = '';
                } else {
                    this.getArea2 = !this.getArea2;
                }
                this.getAddress2(3,id)
            }, 30);
        },
        //社区
        'shopStoreOrginfo.bankAreaId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.street2) {
                    this.shopStoreOrginfo.bankTownId = '';
                } else {
                    this.street2 = !this.street2;
                }
                this.getAddress2(4,id)
            }, 35);
        },
        //市
        'shopStoreOrginfo.ysProvinceId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.ysGetCity) {
                    this.shopStoreOrginfo.ysCityId = '';
                    this.shopStoreOrginfo.ysAreaId = '';
                } else {
                    this.ysGetCity = !this.ysGetCity;
                }
                this.getAddressYs(2,id)
            }, 40);
        },
        //区
        'shopStoreOrginfo.ysCityId'(id) {
            if(!id){
                return;
            }
            setTimeout(() => {
                if (!this.ysGetArea) {
                    this.shopStoreOrginfo.ysAreaId = '';
                } else {
                    this.ysGetArea = !this.ysGetArea;
                }
                this.getAddressYs(3,id)
            }, 50);
        },
        tabs(val){
              this.tabsVal = val  
            // switch (val) {
            if(val == 'zero'){
                this.queryForm.thirdStatus='';
                this.currentPage = 1;
                this.getShopStoreOrgInfoList();
                return
            }
            for (let i = 0; i < this.auditStatusList.length; i++) {
                if(val == 'status_'+i){
                    this.queryForm.thirdStatus = i;
                    this.currentPage = 1;
                    this.getShopStoreOrgInfoList();
                    break;
                }
            }
          
        }
    },
    data() {
        return {
            tabsVal:'',
            auditStatusEnumList: [],
            storeOrgTypeStatusEunmList: [],
            yesNoEunmList: [],
            srcList: [''],

            queryForm: {
                userId: '', //用户id
                storeId: '', //门店id
                subAccount: '', //子商户号
                orgType: '', //组织类型 1小微 2企业 3个体
                licensePic: '', //营业执照图片
                licenseProvinceId: '', //营业执照省
                licenseCityId: '', //营业执照市
                licenseAreaId: '', //营业执照区
                licenseTownId: '', //营业执照乡镇
                licenseName: '', //营业执照名称
                licenseAddress: '', //营业执照地址
                licenseNumber: '', //社会统一信用代码
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机号
                idCard: '', //身份证号
                idCardStartTime: '', //身份证有效开始日期
                idCardEndTime: '', //身份证有效结束日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行卡持有人
                bankMobile: '', //银行预留手机号
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户行省
                bankCityId: '', //开户行市
                bankAreaId: '', //开户行市
                bankTownId: '', //开户行乡镇
                thirdStatus: '', //支付审核状态
                alipayStatus: '', //支付宝支付审核状态
                wxpayStatus: '', //微信支付审核状态
                resultMsg: '', //响应报文
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料 如烟草经营许可证
                changeRequestimg: '', //变更申请图片
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopStoreOrginfoState: 'add',
            shopStoreOrginfoStates: {
                add: '新建进件资料',
                check: '查看进件资料',
                edit: '修改进件资料'
            },
            thirdPartyTypeName:'银盛',
            fullscreenLoading: false,
            multipleSelection: [],
            shopStoreOrginfoList: [],
            shopStoreOrginfo: {
                userId: '', //用户id
                storeId: '', //门店id
                subAccount: '', //子商户号
                orgType: '', //组织类型 1小微 2企业 3个体
                licensePic: '', //营业执照图片
                licenseProvinceId: '', //营业执照省
                licenseCityId: '', //营业执照市
                licenseAreaId: '', //营业执照区
                licenseTownId: '', //营业执照乡镇
                licenseName: '', //营业执照名称
                licenseAddress: '', //营业执照地址
                licenseNumber: '', //社会统一信用代码
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机号
                idCard: '', //身份证号
                idCardStartTime: '', //身份证有效开始日期
                idCardEndTime: '', //身份证有效结束日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行卡持有人
                bankMobile: '', //银行预留手机号
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户行省
                bankCityId: '', //开户行市
                bankAreaId: '', //开户行市
                bankTownId: '', //开户行乡镇
                thirdStatus: '', //支付审核状态
                alipayStatus: '', //支付宝支付审核状态
                wxpayStatus: '', //微信支付审核状态
                resultMsg: '', //响应报文
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料
                wxpayNo: '',
                wxpayNo1: '',
                alipayNo: '',
                alipayNo1: '',
                wxpayApplyQrcode: '',
                wxpayConfirmQrcode: '',
                alipayApplyQrcode: '',
                alipayConfirmQrcode: '',
                ysAreaId: '',
                ysCityId: '',
                ysProvinceId: '',
                mccCode: '',
                mccCodeName: '',
                needQualification: "",
                qualificationStatus: '',
                qualificationPics: '',
                changeRequestimg: '', //变更申请图片
                thirdPartyType: '',//三方类型,1:银盛,2:快付
                servicePhone:'',//客服电话
                serviceEmail:'',//商户邮箱
                deviceNo:"",//终端号
            },
            btnLoading: false,

            rules: {
                // subAccount: [{ required: true, message: '子商户号不能为空', trigger: 'blur' }],
                orgType: [{ required: true, message: '组织类型 1小微 2企业 3个体不能为空', trigger: 'blur' }],
                licensePic: [{ required: true, message: '营业执照图片不能为空', trigger: 'blur' }],
                licenseProvinceId: [{ required: true, message: '营业执照省不能为空', trigger: 'blur' }],
                licenseCityId: [{ required: true, message: '营业执照市不能为空', trigger: 'blur' }],
                licenseAreaId: [{ required: true, message: '营业执照区不能为空', trigger: 'blur' }],
                licenseTownId: [{ required: true, message: '营业执照乡镇不能为空', trigger: 'blur' }],
                licenseName: [{ required: true, message: '营业执照名称不能为空', trigger: 'blur' }],
                licenseAddress: [{ required: true, message: '营业执照地址不能为空', trigger: 'blur' }],
                licenseNumber: [{ required: true, message: '社会统一信用代码不能为空', trigger: 'blur' }],
                licenseStartTime: [{ required: true, message: '营业执照有效开始日期不能为空', trigger: 'blur' }],
                licenseEndTime: [{ required: true, message: '营业执照有效结束日期不能为空', trigger: 'blur' }],
                licenseRange: [{ required: true, message: '营业执照经营范围不能为空', trigger: 'blur' }],
                personName: [{ required: true, message: '法人姓名不能为空', trigger: 'blur' }],
                personMobile: [{ required: true, message: '法人手机号不能为空', trigger: 'blur' }],
                idCard: [{ required: true, message: '身份证号不能为空', trigger: 'blur' }],
                idCardStartTime: [{ required: true, message: '身份证有效开始日期不能为空', trigger: 'blur' }],
                idCardEndTime: [{ required: true, message: '身份证有效结束日期不能为空', trigger: 'blur' }],
                idCardFacade: [{ required: true, message: '身份证正面图片不能为空', trigger: 'blur' }],
                idCardBack: [{ required: true, message: '身份证背面图片不能为空', trigger: 'blur' }],
                idCardAddress: [{ required: true, message: '身份证地址不能为空', trigger: 'blur' }],
                bankAccount: [{ required: true, message: '银行账号不能为空', trigger: 'blur' }],
                bankHolder: [{ required: true, message: '银行卡持有人不能为空', trigger: 'blur' }],
                bankMobile: [{ required: true, message: '银行预留手机号不能为空', trigger: 'blur' }],
                bankCardFacade: [{ required: true, message: '银行卡正面图片不能为空', trigger: 'blur' }],
                bankCardBack: [{ required: true, message: '银行卡背面图片不能为空', trigger: 'blur' }],
                bankAccountVoucher: [{ required: true, message: '对公账户凭证不能为空', trigger: 'blur' }],
                bankName: [{ required: true, message: '银行名称不能为空', trigger: 'blur' }],
                bankSubbranch: [{ required: true, message: '开户支行名称不能为空', trigger: 'blur' }],
                bankProvinceId: [{ required: true, message: '开户行省不能为空', trigger: 'blur' }],
                bankCityId: [{ required: true, message: '开户行市不能为空', trigger: 'blur' }],
                bankAreaId: [{ required: true, message: '开户行市不能为空', trigger: 'blur' }],
                bankTownId: [{ required: true, message: '开户行乡镇不能为空', trigger: 'blur' }],
                thirdStatus: [{ required: true, message: '支付审核状态不能为空', trigger: 'blur' }],
                alipayStatus: [{ required: true, message: '支付宝支付审核状态不能为空', trigger: 'blur' }],
                wxpayStatus: [{ required: true, message: '微信支付审核状态不能为空', trigger: 'blur' }],
                isSign: [{ required: true, message: '是否签名 0否 1是不能为空', trigger: 'blur' }],
                signPic: [{ required: true, message: '签名图片不能为空', trigger: 'blur' }],
                contractUrl: [{ required: true, message: '合同地址不能为空', trigger: 'blur' }],
                otherInfor: [{ required: true, message: '其他补充资料 如烟草经营许可证不能为空', trigger: 'blur' }],
                ysAreaId: [{ required: true, message: '区不能为空', trigger: 'blur' }],
                ysCityId: [{ required: true, message: '市不能为空', trigger: 'blur' }],
                ysProvinceId: [{ required: true, message: '省不能为空', trigger: 'blur' }],
                mccCode: [{ required: true, message: 'mcc编码不能为空', trigger: 'blur' }],
                needQualification: [{ required: true, message: '是否需要其他资质不能为空', trigger: 'blur' }],
                qualificationStatus: [{ required: true, message: '审核状态不能为空', trigger: 'blur' }],
                // serviceEmail:[{ required: true, message: '商户邮箱不能为空', trigger: 'blur' }],
                // servicePhone:[{ required: true, message: '客服手机号码不能为空', trigger: 'blur' }],
            },

            provinceIdList: [], //省信息
            cityIdList: [], //市信息
            areaIdList: [], //区信息
            streetIdList: [],
            getCity: false,//区别是不是get来的
            getArea: false,//区别是不是get来的
            street: false,

            cityIdList2: [], //市信息
            areaIdList2: [], //区信息
            streetIdList2: [],
            getCity2: false,//区别是不是get来的
            getArea2: false,//区别是不是get来的
            street2: false,

            header: {
                token: localStorage.getItem('token')
            },
            action: UPLOAD_API + UPLOAD_PATH,

            retreatDialogVisible: false,
            auditId: '',
            applyRemarks: '',
            retreatRules: {
                desc: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }],
                incomeRatio: [{ required: true, message: '请填写门店收益比例', trigger: 'blur' }],
                resource: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
            },
            retreatForm: {
                resource: '',
                desc: '',
                incomeRatio: ''
            },

            USER_code: USER,
            USER_search: USER_SEARCH,

            imageSrc: '',

            ysProvinceIdList: [], //省信息
            ysCityIdList: [], //市信息
            ysAreaIdList: [], //区信息
            ysGetCity: false,//区别是不是get来的
            ysGetArea: false,//区别是不是get来的

            auditStatusList: [],

            tabs: 'zero',

            mccCodeList: [],
            fileList: [],
            albumList: [],
            temporaryList: [],
        };
    },
    created() {
        // this.getShopStoreOrgInfoList();
        this.getEnum();
        this.getAddress(1);
        this.getAddressYs(1, "0");
      
    },
    methods: {
   
        radioThis(item){
            this.shopStoreOrginfo.mccCode = item.mccCd
            this.shopStoreOrginfo.mccCodeName = item.mchTypeNm
        },
        getMccCode(index){
            let obj = {
                orgType:index,
            }
            get("/shop/store/getYsMccCode" , obj).then((res)=>{
                if(res.success){
                    this.mccCodeList = res.mccInfoList;
                    this.$nextTick(()=>{
                        this.$refs.mccCode.init(this.mccCodeList)
                    })
                }
            })
        },
        // 获取银盛地址信息
        // 获取对应地址
        getAddressYs(type, id=null) {
            get("shop/store/getYsAreaInfoList",{
                cityCode: id,
                pageSize: 50,
                pageNum: 1
            }).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.data.areaInfoList) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.ysProvinceIdList = array
                    }else if(type == 2){
                        this.ysCityIdList = array
                    }else if(type == 3){
                        this.ysAreaIdList = array
                        this.storeAreaIdList = array
                    }
                }
            })
        },

        ShopStoreAudit(item) {
            this.retreatDialogVisible = true;
            this.auditId = item.store.id;
            this.applyRemarks = item.store.remarks;
            this.retreatForm.desc = '';
        },
        resetStatus(id,sign){
            this.$confirm('确认重置吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/storeorginfo/resetStatus',{id:id,sign:sign}).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                    this.getShopStoreOrgInfoList();
                })
            }).catch(() => {
            });

        },
        returnStoreOrgTypeStatus(key){
            for (let i = 0; i < this.storeOrgTypeStatusEunmList.length; i++) {
                if(this.storeOrgTypeStatusEunmList[i].key == key){
                    return this.storeOrgTypeStatusEunmList[i].value
                }
            }
        },
        getImage(url){
            this.srcList = [''];
            this.imageSrc = url;
            this.srcList[0] = url;
            this.$refs.images.showViewer = true;
        },
        seeImages(){
            this.srcList = this.temporaryList
            this.$refs.images.showViewer = true;
        },
        handleRemove(file, fileList) {
           
            for (let i = 0; i < this.temporaryList.length; i++) {
                console.log(file.url == this.temporaryList[i])
                if (file.url == this.temporaryList[i]) {
                    this.temporaryList.splice(i, 1);
                }
            }
            this.albumList = this.temporaryList.join('|');

        },
        //上传成功
        handleSuccess(response, file, fileList) {
         
            this.temporaryList.push(file.response.url);
            this.albumList = this.temporaryList.join('|');
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        // 审核取消按钮
        handleCloseRetreat() {
            this.retreatDialogVisible = false;
            this.auditId = '';//关闭后清除点击的id
            this.applyRemarks = ''; //关闭后清除申请人的说明
            this.retreatForm.resource = '';//关闭后把选择的按钮置空
            this.retreatForm.desc = '';
            this.retreatForm.incomeRatio = '';
        },
        getSearchValueUser(val){
            this.queryForm.userId = val;
        },
        //审核确认按钮
        retreatSuccess(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //处理选择同意&拒绝
                    this.retreatDialogVisible = false;
                    let status = 1;
                    this.retreatForm.resource == 'true' ? status = 2 : status = 3;
                    get(`/shop/store/auditStore`, {
                        id: this.auditId,
                        status: status,
                        refuseReason: this.retreatForm.desc,
                        incomeRatio: this.retreatForm.incomeRatio
                    }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.handleCloseRetreat();
                            this.getShopStoreOrgInfoList();
                        }else{
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                }
            });
        },
        // 获取对应地址
        getAddress(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 1){
                        this.provinceIdList = array
                    }else if(type == 2){
                        this.cityIdList = array
                    }else if(type == 3){
                        this.areaIdList = array
                    }else if(type == 4){
                        this.streetIdList = array
                    }
                }
            })
        },
        // 获取对应地址
        getAddress2(type, id=null) {
            get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
                if(res.success){
                    let array = []
                    for (let listElement of res.list) {
                        listElement.id = String(listElement.id)
                        array.push(listElement)
                    }
                    if(type == 2){
                        this.cityIdList2 = array
                    }else if(type == 3){
                        this.areaIdList2 = array
                    }else if(type == 4){
                        this.streetIdList2 = array
                    }
                }
            })
        },
        beforeImageUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 50MB!');
            }
            return isLt2M;
        },
        // 进件
        //上传缩略图
        uploadImage11(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.signPic = res.url;
                }
            });
        },
        uploadImage12(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.contractUrl = res.url;
                }
            });
        },
        uploadImage21(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.licensePic = res.url;
                }
            });
        },
        uploadImage31(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.idCardFacade = res.url;
                }
            });
        },
        uploadImage32(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.idCardBack = res.url;
                }
            });
        },
        uploadImage41(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.bankCardFacade = res.url;
                }
            });
        },
        uploadImage42(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.bankCardBack = res.url;
                }
            });
        },
        uploadImage43(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.bankAccountVoucher = res.url;
                }
            });
        },
        uploadImage51(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.wxpayApplyQrcode = res.url;
                }
            });
        },
        uploadImage52(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.wxpayConfirmQrcode = res.url;
                }
            });
        },
        uploadImage53(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.alipayApplyQrcode = res.url;
                }
            });
        },
        uploadImage54(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.alipayConfirmQrcode = res.url;
                }
            });
        },
        uploadImage55(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
            if (!types.includes(file.type)) {
                this.$message.error('图片类型错误!');
            }
            const formData = new FormData();
            formData.append('file', file);
            upload(UPLOAD_PATH, formData).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo.changeRequestimg = res.url;
                }
            });
        },


        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopStoreOrgInfoList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopStoreOrginfoList = [];
        },
        resetDialog() {
            this.shopStoreOrginfoState = 'add';
            this.showDialog = false;
            this.queryForm = {
                userId: '', //用户id
                storeId: '', //门店id
                subAccount: '', //子商户号
                orgType: '', //组织类型 1小微 2企业 3个体
                licensePic: '', //营业执照图片
                licenseProvinceId: '', //营业执照省
                licenseCityId: '', //营业执照市
                licenseAreaId: '', //营业执照区
                licenseTownId: '', //营业执照乡镇
                licenseName: '', //营业执照名称
                licenseAddress: '', //营业执照地址
                licenseNumber: '', //社会统一信用代码
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机号
                idCard: '', //身份证号
                idCardStartTime: '', //身份证有效开始日期
                idCardEndTime: '', //身份证有效结束日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行卡持有人
                bankMobile: '', //银行预留手机号
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户行省
                bankCityId: '', //开户行市
                bankAreaId: '', //开户行市
                bankTownId: '', //开户行乡镇
                thirdStatus: '', //支付审核状态
                alipayStatus: '', //支付宝支付审核状态
                wxpayStatus: '', //微信支付审核状态
                resultMsg: '', //响应报文
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料 如烟草经营许可证
            };
            this.getShopStoreOrgInfoList();
        },
        resetDialogEdit() {
            this.closeDialog();
            this.shopStoreOrginfoState = 'add';
            this.getShopStoreOrgInfoList();
        },
        closeDialog() {
            this.showDialog = false;
            this.shopStoreOrginfo = {
                userId: '', //用户id
                storeId: '', //门店id
                subAccount: '', //子商户号
                orgType: '', //组织类型 1小微 2企业 3个体
                licensePic: '', //营业执照图片
                licenseProvinceId: '', //营业执照省
                licenseCityId: '', //营业执照市
                licenseAreaId: '', //营业执照区
                licenseTownId: '', //营业执照乡镇
                licenseName: '', //营业执照名称
                licenseAddress: '', //营业执照地址
                licenseNumber: '', //社会统一信用代码
                licenseStartTime: '', //营业执照有效开始日期
                licenseEndTime: '', //营业执照有效结束日期
                licenseRange: '', //营业执照经营范围
                personName: '', //法人姓名
                personMobile: '', //法人手机号
                idCard: '', //身份证号
                idCardStartTime: '', //身份证有效开始日期
                idCardEndTime: '', //身份证有效结束日期
                idCardFacade: '', //身份证正面图片
                idCardBack: '', //身份证背面图片
                idCardAddress: '', //身份证地址
                bankAccount: '', //银行账号
                bankHolder: '', //银行卡持有人
                bankMobile: '', //银行预留手机号
                bankCardFacade: '', //银行卡正面图片
                bankCardBack: '', //银行卡背面图片
                bankAccountVoucher: '', //对公账户凭证
                bankName: '', //银行名称
                bankSubbranch: '', //开户支行名称
                bankProvinceId: '', //开户行省
                bankCityId: '', //开户行市
                bankAreaId: '', //开户行市
                bankTownId: '', //开户行乡镇
                thirdStatus: '', //支付审核状态
                alipayStatus: '', //支付宝支付审核状态
                wxpayStatus: '', //微信支付审核状态
                resultMsg: '', //响应报文
                isSign: '', //是否签名 0否 1是
                signPic: '', //签名图片
                contractUrl: '', //合同地址
                otherInfor: '', //其他补充资料 如烟草经营许可证
                wxpayNo: '',
                wxpayNo1: '',
                alipayNo: '',
                alipayNo1: '',
                wxpayApplyQrcode: '',
                wxpayConfirmQrcode: '',
                alipayApplyQrcode: '',
                alipayConfirmQrcode: '',
                ysProvinceId: '',
                ysCityId: '',
                ysAreaId: '',
                mccCode: '',
                mccCodeName: '',
                needQualification: "",
                qualificationStatus: '',
                qualificationPics: '',
                servicePhone:'',
                serviceEmail:'',
                deviceNo:""
            };
            this.albumList = [];
            this.temporaryList = [];
            this.fileList = [];
        },
        blurService(row){
            if(row == 1){
              const phoneRegex = /^1[3-9]\d{9}$/
                  if (this.shopStoreOrginfo.servicePhone && !phoneRegex.test(this.shopStoreOrginfo.servicePhone)) {
                      this.$message({
                            message: '请输入正确手机号码',
                            type: 'warning'
                            });
                      return
                  }
          
            }else if(2){
                 const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                  if (this.shopStoreOrginfo.serviceEmail && !emailRegex.test(this.shopStoreOrginfo.serviceEmail)) {
                      this.$message({
                            message: '请输入正确邮箱',
                            type: 'warning'
                            });
                      return
                  } 
            }
        },
        submitForm() {
            delete this.shopStoreOrginfo.licenseProvince
            delete this.shopStoreOrginfo.licenseCity
            delete this.shopStoreOrginfo.licenseArea
            delete this.shopStoreOrginfo.licenseTown
            delete this.shopStoreOrginfo.bankProvince
            delete this.shopStoreOrginfo.bankCity
            delete this.shopStoreOrginfo.bankArea
            delete this.shopStoreOrginfo.bankTown
            delete this.shopStoreOrginfo.store
            delete this.shopStoreOrginfo.user

            this.shopStoreOrginfo.qualificationPics  = this.albumList;
          
            
            if (this.shopStoreOrginfoState == 'add') {
                this.$refs.shopStoreOrginfoForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/storeorginfo/add`, { ...this.shopStoreOrginfo }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStoreOrgInfoList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopStoreOrginfoState == 'edit') {
                this.$refs.shopStoreOrginfoForm.validate((valid) => {
                    if (valid) {
                        post(`/shop/storeorginfo/edit`, { ...this.shopStoreOrginfo }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                // this.resetShopStoreOrgInfoList();
                                this.resetDialogEdit();
                                 
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    
                    }else{
                           this.$message({
                                showClose: true,
                                message: '信息请填写完整',
                                type: 'warning'
                                }); 
                    }
                });
            }
        },
         
        submitBankInfo(){
             //将this.shopStoreOrginfo中的数据与obj的数据进行对应替换
            let obj = {
               store_id:this.shopStoreOrginfo.storeId,
               bank_account:this.shopStoreOrginfo.bankAccount,
               bank_holder:this.shopStoreOrginfo.bankHolder,
               bank_mobile:this.shopStoreOrginfo.bankMobile,
               bank_account_voucher:this.shopStoreOrginfo.bankAccountVoucher,
               bank_name:this.shopStoreOrginfo.bankName,
               bank_subbranch:this.shopStoreOrginfo.bankSubbranch,
               id_card:this.shopStoreOrginfo.idCard,
               bank_card_facade:this.shopStoreOrginfo.bankCardFacade,
               bank_card_back:this.shopStoreOrginfo.bankCardBack,
               changeRequestimg: this.shopStoreOrginfo.changeRequestimg,
            }
            
            if (this.shopStoreOrginfo.orgType == 2) {
                obj.bank_account_voucher = this.shopStoreOrginfo.bankAccountVoucher;
            } else {
                obj.bank_card_facade = this.shopStoreOrginfo.bankCardFacade;
                obj.bank_card_back = this.shopStoreOrginfo.bankCardBack;
            }

            axios({
                method: 'get',
                url: 'https://pay.tianelive.com/index.php/Updata/upjsdata',
                // url: 'https://tianyilifetest.tianelive.com/index.php/Updata/upjsdata',//测试
                params: obj
            })
                .then((res) => {
                    if (res.data.success) {
                        this.$message({
                            message: res.data.msg,
                            type: 'success',
                            duration: 2000
                        });
                        this.resetDialogEdit();
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: 'error',
                        })
                    }
                })
        },
        addShopStoreOrgInfo() {
            this.showDialog = true;
            this.shopStoreOrginfoState = 'add';
        },
        checkShopStoreOrgInfo(shopStoreOrginfoId) {
            console.log(shopStoreOrginfoId);
            this.currentShopStoreOrgInfoId = shopStoreOrginfoId;

            this.getShopStoreOrgInfoById();
            this.showDialog = true;
            this.shopStoreOrginfoState = 'check';
        },
        editShopStoreOrgInfo(shopStoreOrginfoId) {
            console.log('shopStoreOrginfo', shopStoreOrginfoId);
            if (shopStoreOrginfoId) {
                this.currentShopStoreOrgInfoId = shopStoreOrginfoId;
                this.getShopStoreOrgInfoById();
            } else {
                this.shopStoreOrginfo = { ...this.shopStoreOrginfo, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopStoreOrginfoState = 'edit';
        },
        deleteShopStoreOrgInfo(shopStoreOrginfoId) {
            let ids = '';
            if (shopStoreOrginfoId) {
                ids = shopStoreOrginfoId;
            } else {
                ids = this.multipleSelection.map((shopStoreOrginfo) => shopStoreOrginfo.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/storeorginfo/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopStoreOrgInfoList();
                            this.getShopStoreOrgInfoList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshShopStoreOrgInfoList() {
            this.resetShopStoreOrgInfoList();
            this.getShopStoreOrgInfoList();
        },
        getShopStoreOrgInfoList(query = {}) {
            this.loading = true;
            get(`/shop/storeorginfo/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopStoreOrginfoList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopStoreOrgInfoById() {
            get(`/shop/storeorginfo/get`, { id: this.currentShopStoreOrgInfoId }).then((res) => {
                if (res.success) {
                    this.shopStoreOrginfo = { ...this.shopStoreOrginfo, ...res.shopStoreOrginfo };
                    this.fileList = [];
                    this.albumList = [];
                    this.temporaryList = [];
                    if (res.shopStoreOrginfo.qualificationPics) {
                        let str = res.shopStoreOrginfo.qualificationPics;
                        var list = str.split('|');

                        this.fileList = list.map((item) => {
                            return {
                                name: item,
                                url: item
                            };
                        });
                        for (let item of list) {
                            this.temporaryList.push(item);
                        }
                        this.albumList = '';
                        this.albumList = this.temporaryList.join('|');
                    }else{
                        this.shopStoreOrginfo.qualificationPics = ""
                    }
                    console.log(this.temporaryList);
                    this.getCity = true;
                    this.getArea = true;
                    this.street = true;
                    this.getCity2 = true;
                    this.getArea2 = true;
                    this.street2 = true;

                    this.ysGetCity = true;
                    this.ysGetArea = true;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopStoreOrgInfoList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/storeorginfo/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/storeorginfo/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/storeorginfo/importData`, formData);
            this.refreshShopStoreOrgInfoList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopStoreOrgInfoList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopStoreOrgInfoList();
        },

        // 大图预览
        updateSrcList(src) {
            this.srcList[0] = src
        },

        // 获取枚举
        getEnum(){
            get('/shop/utils/getEnum',{
                enumType: "store_org_type_status"
            }).then((res)=>{
                if(res.success){
                    this.storeOrgTypeStatusEunmList = res.enumList;
                }
            })

            get('/mpp/utils/getEnum',{
                enumType: "yes_no"
            }).then((res)=>{
                if(res.success){
                    this.yesNoEunmList = res.enumList;
                }
            })

            get('/mpp/utils/getEnum', {
                enumType: 'audit_status'
            }).then((res) => {
                if(res.success){
                    this.auditStatusEnumList = res.enumList;
                }
            });

            get('/shop/utils/getEnum', {
                enumType: 'audit_v3_status'
            }).then((res) => {
                if(res.success){
                    this.auditStatusList = res.enumList;
                }
            });
        },

        // 计算AuditStatus
        computeAuditStatus(type) {
            for (let i = 0; i < this.auditStatusList.length; i++) {
                if (this.auditStatusList[i].key == type) {
                    return this.auditStatusList[i].value;
                }
            }
        },

        // 提交进件
        onRegister(storeId){
            this.$confirm('确认资料核对无误', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/submitStoreOrgInfoV3',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })
            }).catch(() => {
            });
        },

        // 上传图片
        onUpload(storeId){
            this.$confirm('确认操作无误', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/imgUploadDemoV3',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })
            }).catch(() => {
            });
        },

        // 上传修改资料
        onEditRegister(storeId){
            this.$confirm('确认资料核对无误', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/editStoreOrgInfoV3',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })
            }).catch(() => {
            });
        },

        // 确认资料
        onConfirm(storeId){
            this.$confirm('确认操作无误', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/confirmInfoV3',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })
            }).catch(() => {
            });
        },

        // 合同申请
        onContract(storeId,type,thirdStatus){
            this.$confirm('确认操作无误', '提示', {
                type: 'warning'
            }).then(() => {
                get('/shop/store/getSignContractV3',{
                    storeId,
                    type
                }).then((res)=>{
                    if(res.success){
                        this.$message({
                            message:res.msg,
                            type: 'success'
                            });
                        if(this.tabs == "zero"){
                            this.queryForm.thirdStatus = '';
                        }else{
                            this.queryForm.thirdStatus = thirdStatus;
                        }
                         this.resetShopStoreOrgInfoList();
                         this.getShopStoreOrgInfoList();
 
                    }
                })
            }).catch(() => {
            });
        },

        // 短信重发
        onResendSMS(storeId){
            this.$confirm('确认操作无误', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/resendSmsV3',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })
            }).catch(() => {
            });
        },

        // 重新报备微信认证
        wxReport(storeId){
            this.$confirm('确认要进行微信认证吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/wxReport',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })

            }).catch(() => {
            });
        },

        // 微信认证
        wxReportV3(storeId){
            this.$confirm('确认要进行微信认证吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/wxReportV3',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })

            }).catch(() => {
            });
        },

        // 重新报备支付宝认证
        aliReport(storeId){
            this.$confirm('确认要进行支付宝认证吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/aliReport',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })

            }).catch(() => {
            });
        },

        // 支付宝认证
        aliReportV3(storeId){
            this.$confirm('确认要进行支付宝认证吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/aliReportV3',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })

            }).catch(() => {
            });
        },

        // 申请报备
        reportBei(storeId){
            this.$confirm('确认要进行报备吗?', '提示', {
                type: 'warning'
            }).then(() => {
                this.fullscreenLoading = true;
                get('/shop/store/reportBei',{
                    storeId
                }).then((res)=>{
                    this.$confirm(res.msg, '提示', {type:'warning',showCancelButton: false})
                    this.fullscreenLoading = false;
                })

            }).catch(() => {
            });
        },
        // 申请报备
        changeInformationInquiry(Id){
            axios({
                    method: 'get',
                    url: 'https://pay.tianelive.com/Updata/queryCustChangedo',
                    params: {
                        store_id: Id
                    }
                }).then((res) => {
                    if(res.data.success){
                        this.$confirm(res.data.result.statusMsg, '变更信息查询进度', {type:'warning',showCancelButton: false})
                    }else{
                        this.$message.error(res.data.msg);
                    }
                });
        },
        //快付进件
        quickPaymentForIncomingItems(row){
            this.$confirm('确认要进行快付进件吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                get('/shop/store/fastRegister',{storeId : row.storeId}).then(res=>{
                      if(res.success){
                          this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                       this.getShopStoreOrgInfoList()
                    }
                })
            })
        },
        //快付进件修改
        quickPaymentForIncomingModifications(row){
            this.$confirm('确认要修改快付进件吗?', '提示', {
                type: 'warning'
            }).then(()=>{
                get('/shop/store/fastRegisterUpdate',{storeId : row.storeId}).then(res=>{
                      if(res.success){
                          this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                       this.getShopStoreOrgInfoList()
                    }
                })
            })
        },
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.content{
    background-color: #fff;
    padding: 10px;
    height: 100%;
}
.page-content{
    height: 93%;
    padding: 0;
    border: 0;
}

.avatar {
    width: 130px;
    height: 130px;
    display: block;
}

::v-deep .el-upload--text {
    width: 130px;
    height: 130px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .el-range-separator {
    width: 20px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 130px;
    height: 130px;
    line-height: 130px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}


.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        padding: 0px 10px;
        box-sizing: border-box;
        border-radius: 5px;
        margin-left: 10px;
        border: 1px solid #409eff;
        color: #fff;
        background-color: #409eff;
        margin-top: .3125rem;
    }
}

.flex{
    display: flex;
    align-items: center;
    justify-content: center;
}
.active{
    color:#67C23A;
}
</style>